/**
 * Become Contractor Banner
 *
 * CTA banner with image on the left:
 * - Professional image on the left
 * - Heading and description on the right
 * - "Become a Service Provider" button
 */

'use client';

import { useTranslations } from 'next-intl';
import { Container } from '@/src/shared/ui/Container';
import { Typography } from '@/src/shared/ui/typography/Typography';
import { PrimaryButton } from '@/src/shared/ui/button/PrimaryButton';

export function BecomeContractorBanner() {
  const t = useTranslations('landing.becomeContractor');

  const handleBecomeContractor = () => {
    console.log('Become a Service Provider clicked');
    // Navigate to service provider registration
  };

  return (
    <section className="container-auto">      
        <div className="w-full bg-gradient-to-b from-[#FFFDE9] to-[#D7FAD6] rounded-3xl overflow-hidden">
          {/* Mobile: Image top, Text bottom | Tablet+: Image left, Text right */}
          <div className="flex flex-col md:flex-row items-stretch min-h-[500px]">
            {/* Left Image - 100% mobile, 55% tablet+ */}
            <div className="flex-[0_0_100%] md:flex-[0_0_55%] relative">
              <div className="relative h-[300px] md:h-full w-full">
                <img
                  src="/images/banners/become_contractor.png"
                  alt={t('imageAlt')}
                  className="w-full h-full object-cover rounded-t-3xl md:rounded-none md:rounded-l-3xl"
                />
              </div>
            </div>

            {/* Right Content - 100% mobile, 45% tablet+ */}
            <div className="flex-[0_0_100%] md:flex-[0_0_45%] flex items-center justify-center p-8 md:p-12 lg:p-16">
              <div className="space-y-6 md:space-y-8 max-w-lg text-center md:text-left">
                <Typography
                  variant="h1"
                  weight="bold"
                  className="text-text-primary leading-tight"
                >
                  {t('title')}
                </Typography>

                <Typography
                  variant="body"
                  className="text-text-primary leading-relaxed"
                >
                  {t('description')}
                </Typography>

                <div className="flex justify-center md:justify-start">
                  <PrimaryButton
                    onClick={handleBecomeContractor}
                    className="rounded-btn-pill px-12 py-4 bg-accent-primary hover:bg-accent-hover active:bg-accent-active transition-colors"
                  >
                    <Typography variant="h3" color="inherit" weight="semibold">
                      {t('button')}
                    </Typography>
                  </PrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>      
    </section>
  );
}
